import axios from 'axios'

import asPromise from './../util/as-promise'

import VueI18n from 'vue-i18n'
import SessionManager from '@src/lib/session_manager'
import { AVAILABLE_LOCALES } from '@src/util/constants'

class MessagesProvider {

  private basePath = '/assets/i18n/'
  private cacheBust = String(Date.now())

  constructor (private locales: string[], private projects: string[]) {
  }

  async fetchMessages () {
    let user = await SessionManager.Instance.restoreUser().catch(() => null)
    let locale = user && user.locale && AVAILABLE_LOCALES.includes(user.locale) ? user.locale : 'en-gb'
    if (!this.locales.includes(locale)) {
      this.locales.push(locale)
    }
    let mergedMessages: VueI18n.LocaleMessages = {}

    for (let locale of this.locales) {
      for (let project of this.projects) {
        const path = `${this.basePath}${project}/${locale}.json?v=${this.cacheBust}`
        let messages: any = {}
        try {
          messages = await this.fetchJSON(path)
        } catch (err) {
          // tolerate missing/invalid message files for a project/locale
          // eslint-disable-next-line no-console
          console.error('Failed to load messages for', { project, locale, path, err })
        }

        if (!mergedMessages.hasOwnProperty(locale)) {
          mergedMessages[locale] = {}
        }

        for (let key in messages) {
          if (messages.hasOwnProperty(key)) {
            mergedMessages[locale][key] = messages[key]
          }
        }
      }
    }

    return mergedMessages
  }

  private fetchJSON (filepath: string) {
    return asPromise<VueI18n.LocaleMessages>(
      axios.get(filepath, {
        headers: {
          'content-type': 'application/json'
        }
      })
    )
  }

}

export default MessagesProvider
